/**
 * Creative hook (PRD-4996): UA encodes the concept as field 6 of the 15-field ad name
 * (`vid_11463_v1_taichiwalk_Hook_relationship_…`). The host reads it from `utm_ad_name`;
 * no dictionary, no extra query param. Layouts see it as the `hook` variable.
 */
export const HOOK_VARIABLE = 'hook';

const CONCEPT_FIELD_INDEX = 5;
const CONCEPT_TOKEN = /^[a-z0-9]+$/;

/** Lowercased concept token, or '' for short names, unreplaced macros and anything not [a-z0-9]. */
export const hookFromAdName = (adName: string | null | undefined): string => {
  const token = (adName ?? '').split('_')[CONCEPT_FIELD_INDEX]?.trim().toLowerCase() ?? '';
  return CONCEPT_TOKEN.test(token) ? token : '';
};

export const HOOK_TITLE_VARIABLE = 'hookTitle';
export const HOOK_IMAGE_VARIABLE = 'hookImage';

const CREATIVE_NUM_FIELD_INDEX = 1;

/** Creative number (field 2, `vid_11964_v2_…` → `11964`): one scenario across versions and languages. */
export const creativeNumFromAdName = (adName: string | null | undefined): string => {
  const token = (adName ?? '').split('_')[CREATIVE_NUM_FIELD_INDEX]?.trim() ?? '';
  return /^\d+$/.test(token) ? token : '';
};
